import QueryReducer from './QueryReducer.js';
const mode = 'history';
export default QueryReducer.create({
  mode
});